import firestore from "../firebase/firestore";
import api from "../utils/api";

export const getConsumerUnit = (id) => {
  return firestore.doc(`consumer_units/${id}`).get();
};

export const getConsumerUnitByUser = (customer_id) => {
  return firestore
    .collection("consumer_units")
    .where("user_id", "==", customer_id)
    .limit(1)
    .get();
};

export const getConsumerUnits = (args) => {
  let ref = firestore.collection("consumer_units");
  if (args.searchBy) {
    ref = ref.where(
      args.searchBy.field,
      args.searchBy.operator,
      args.searchBy.value,
    );
    if (args.searchBy.operator !== "==")
      ref = ref.orderBy(args.searchBy.field, "asc");
  } else if (args.orderBy) {
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  } else if (args.orderBy) {
    // console.log('field: ', args.orderBy.field)
    // console.log('direction: ', args.orderBy.direction)
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  }
  if (args.limit && args.page) {
    ref = ref.limit(args.limit);
    ref = ref.offset(args.page * args.limit - args.limit);
  }

  return ref;
};

export const getConsumerUnitsCache = (args) => {
  let ref = firestore.collection("consumer_units");
  if (args.searchBy) {
    ref = ref.where(
      args.searchBy.field,
      args.searchBy.operator,
      args.searchBy.value,
    );
    if (args.searchBy.operator !== "==")
      ref = ref.orderBy(args.searchBy.field, "asc");
  } else if (args.orderBy) {
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  } else if (args.orderBy) {
    // console.log('field: ', args.orderBy.field)
    // console.log('direction: ', args.orderBy.direction)
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  }
  if (args.limit && args.page) {
    ref = ref.limit(args.limit);
    ref = ref.offset(args.page * args.limit - args.limit);
  }

  // return ref.get()

  // db.collection("cities").where("state", "==", "CA")
  return ref;
};

export const cancelConsumerUnit = (consumerUnit) =>
  api.post(process.env.VUE_APP_CANCEL_CONSUMER_UNIT, consumerUnit);
export const reactivateConsumerUnit = (consumerUnit) =>
  api.post(process.env.VUE_APP_REACTIVATE_CONSUMER_UNIT, consumerUnit);

export const updateConsumerUnit = async (id, data) => {
  return await firestore.doc(`consumer_units/${id}`).update(data);
};

export const getConsumerUnitsUsers = (args) => {
  let ref = firestore.collection("consumer_units");
  // console.log('searchBy: ', args.searchBy)
  if (args.searchBy) {
    ref = ref.where(
      args.searchBy.field,
      args.searchBy.operator,
      args.searchBy.value,
    );
    if (args.searchBy.operator !== "==")
      ref = ref.orderBy(args.searchBy.field, "asc");
  } else if (args.orderBy) {
    // console.log('field: ', args.orderBy.field)
    // console.log('direction: ', args.orderBy.direction)
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  }
  if (args.limit && args.page) {
    // console.log('args.limit: ', args.limit)
    // console.log('args.page: ', args.page)
    ref = ref.limit(args.limit);
    // console.log('startAt: ', (args.page * args.limit) - args.limit)
    ref = ref.startAt(args.page * args.limit - args.limit);
    // ref = ref.offset((args.page * args.limit) - args.limit)
  }

  // console.log(ref)
  // return ref.get()
  return ref.get();
  // 	console.log('ucs size: ', ucs.size)
  // 	processados = processados + 1
  // 	const consumer_units = [];
  // 	ucs.docs.map(doc => {
  // 		const customer_id = doc.data().user_id
  // 		// console.log('customer_id: ', customer_id)
  // 		firestore.doc(`users/${customer_id}`).get()
  // 			.then(user => {
  // 				// console.log('user: ', user.data().name)
  // 				consumer_units.push({
  // 					...doc.data(),
  // 					id: doc.id,
  // 					user: user.data()
  // 				})
  // 			})
  // 		if(processados === ucs.size) {
  // 			return consumer_units
  // 		}
  // 	})
  // })
  // return ref
};

// export const UCs = () => {
// 	let first = firestore.collection('consumer_units')
//   		.orderBy('created_at')
//   		.limit(3);
// 	console.log('first: ', first)
// 	let paginate = first.get()
// 		.then((snapshot) => {
// 			// ...

// 			// Get the last document
// 			let last = snapshot.docs[snapshot.docs.length - 1];

// 			// Construct a new query starting at this document.
// 			// Note: this will not have the desired effect if multiple
// 			// cities have the exact same population value.
// 			let next = firestore.collection('consumer_units')
// 			.orderBy('created_at')
// 			.startAfter(last.data().population)
// 			.limit(3);

// 			// Use the query for pagination
// 			// ...
// 		});
// 	console.log('paginate: ', paginate)
// 	return {first, paginate}
// }

export async function updateConsumerUnitCore(consumer_unit, updateData) {
  api.put(process.env.VUE_APP_UPDATE_CONSUMER_UNIT + consumer_unit, updateData);
}

export async function getConsumerUnitChangelog(id) {
  const historyRef = await firestore
    .collection("consumer_units")
    .doc(id)
    .collection("changelog")
    .get();

  return historyRef.docs.map((history) => history.data());
}
